module.exports = __webpack_public_path__ + "static/media/inviter_now_btn.aeb757ca.png";